export const createStyles = (theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    height: 'auto',
    p: 2,
    gap: 1,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: 0,
    gap: 1,
  },
  headerText: {
    minWidth: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: { xs: '0.75rem', lg: '1rem' },
    lineHeight: '20px',
    letterSpacing: '0.14px',
    color: theme.palette.text.primary,
  },
  viewButton: {
    flexShrink: 0,
    minWidth: 0,
    p: 0,
    border: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: { xs: '0.75rem', lg: '1rem' },
    lineHeight: '20px',
    letterSpacing: '0.14px',
    textAlign: 'right',
    color: theme.palette.primary.main,
    '&:hover': {
      border: 0,
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  divider: {
    width: '100%',
    borderColor: theme.palette.divider,
  },
  metadata: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    minHeight: { xs: 72, md: 66 },
    py: 2,
    pr: 2,
    pl: 1,
    gap: 1,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
    backgroundColor: theme.palette.background.default,
  },
  scheduledDetails: {
    display: 'flex',
    alignItems: { xs: 'flex-start', md: 'center' },
    flex: 1,
    minWidth: 0,
    gap: 1,
  },
  scheduleIcon: {
    width: 20,
    height: 20,
    fontSize: 20,
    flexShrink: 0,
    mt: { xs: 0.25, md: 0 },
    color: theme.palette.text.secondary,
  },
  scheduledText: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    flexWrap: { md: 'wrap' },
    minWidth: 0,
    columnGap: { md: 0.5 },
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: { xs: '0.75rem', lg: '1rem' },
    lineHeight: '20px',
    letterSpacing: '0.14px',
    color: theme.palette.mode === 'dark' ? '#FFFFFFB2' : '#00000099',
  },
  scheduledDate: {
    overflowWrap: 'anywhere',
  },
  metadataActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    minWidth: 0,
    gap: 0.5,
  },
  changeButton: {
    minWidth: 0,
    px: 1,
    py: 0.5,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '0.8125rem',
    lineHeight: '22px',
    letterSpacing: 0,
    textAlign: 'center',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    '& .MuiButton-endIcon': {
      ml: 0.25,
    },
  },
  actionsButton: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  postTitle: {
    minWidth: 0,
    m: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: { xs: '0.75rem', lg: '0.875rem' },
    lineHeight: '20px',
    letterSpacing: '0.14px',
    color: theme.palette.text.primary,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    lineClamp: 2,
    maxHeight: '40px',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
  },
  postPreview: {
    minWidth: 0,
    m: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: { xs: '0.75rem', lg: '0.875rem' },
    lineHeight: '166%',
    letterSpacing: 0,
    color: theme.palette.text.primary,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    lineClamp: 2,
    maxHeight: { xs: '39.84px', lg: '46.48px' },
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
  },
  attachments: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: 0.5,
    color: theme.palette.text.primary,
  },
  attachmentIcon: {
    width: 20,
    height: 20,
    flexShrink: 0,
    color: 'inherit',
  },
  attachmentText: {
    minWidth: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: { xs: '0.75rem', lg: '0.875rem' },
    lineHeight: '166%',
    letterSpacing: 0,
    color: 'inherit',
  },
});
